import { useCallback, useEffect, useRef, useState } from 'react';
const STEP_MS = 100;
const DEFAULT_DURATION_MS = 80000;
export const useVideoProgress = (options)=>{
    var _ref;
    const durationMs = (_ref = options === null || options === void 0 ? void 0 : options.durationMs) !== null && _ref !== void 0 ? _ref : DEFAULT_DURATION_MS;
    const onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef(null);
    const start = useCallback(()=>{
        if (intervalRef.current) return;
        const increment = STEP_MS / durationMs * 100;
        intervalRef.current = setInterval(()=>{
            let completed = false;
            setProgress((prev)=>{
                const next = prev + increment;
                if (next >= 100) {
                    completed = true;
                    return 100;
                }
                return next;
            });
            if (completed) {
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
                onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            }
        }, STEP_MS);
    }, [
        durationMs,
        onComplete
    ]);
    const pause = useCallback(()=>{
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    const reset = useCallback(()=>{
        pause();
        setProgress(0);
    }, [
        pause
    ]);
    useEffect(()=>()=>pause(), [
        pause
    ]);
    return {
        progress,
        start,
        pause,
        reset
    };
};
